import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { categories } from '@/mocks/site';
import TopicCard from '@/components/base/TopicCard';

const catName = (id: string) => categories.find((c) => c.id === id)?.name ?? '专题';

export default function FeaturedTopics() {
  const featured = topics.slice(0, 4);
  const [main, ...rest] = featured;

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-12">
          <p className="text-xs tracking-[0.2em] text-primary-600 font-medium mb-2 uppercase">
            Featured / 精选整理
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            本期最值得回看的专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
            每个专题都把事件的前因后果串成一条线，从背景到尾声，帮你用最短时间看懂全部进展。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <Link
            to={`/topic/${main.id}`}
            className="group relative lg:col-span-2 flex flex-col justify-end min-h-[340px] md:min-h-[420px] rounded-lg overflow-hidden"
          >
            <img
              src={main.cover}
              alt={`${main.title} - 精选专题封面`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent" />
            <div className="relative z-10 p-6 md:p-8">
              <span className="inline-block px-2.5 py-1 rounded-md text-xs bg-accent-500 text-secondary-950 mb-3">
                {catName(main.categoryId)}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 leading-snug line-clamp-2">
                {main.title}
              </h3>
              <p className="mt-3 text-sm text-background-100/85 line-clamp-2 max-w-xl">{main.summary}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-accent-400">
                查看专题
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            {rest.map((t) => (
              <TopicCard key={t.id} topic={t} categoryName={catName(t.categoryId)} variant="compact" />
            ))}
            <Link
              to="/library"
              className="flex items-center justify-between p-4 rounded-lg border border-dashed border-background-300 hover:border-primary-400 transition-colors group"
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors">
                浏览资源库全部专题
              </span>
              <i className="ri-arrow-right-line text-primary-600" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}